import {Component, h} from "preact";
import styles from './style.module.scss';
import {Image, Product, Variant} from "../../../models/product";
import {connect} from "redux-zero/preact";
import actions from "../../../store/actions";
import ProductTag from "../../product-tag";
import {icons} from "../../icons";
import ProductInfoMobile from "./product-info";
import {navigationService} from "../../../services/navigation-service";
import {customerService} from "../../../services/customer-service";
import {Like} from "../../../models/customer";
import {withDeviceIndicator} from "../../../hoc/withDeviceIndicator";
import {i18nService} from "../../../services/i18n-service";
import Button from "../../button";
import {route} from "preact-router";
import ImagePreview from "../../image-preview";
import {Dimension} from "../../../services/tracking-service";
import ImageGallery from "../../image-gallery";
import {NY_CountryService} from "../../../services/country-service";
import App from "../../app";

interface Props {
  toggleLike(variant: Variant, newLikeState: boolean, dimension: string): void;

  product: Product;
  variant: Variant;
  likes: Like[];
}

interface State {
  isLiked?: boolean;
  visibleImage?: HTMLElement;
  fullscreen: { show: boolean, start: Image | null };
}

const mapToProps = ({likes}) => ({likes});

class DetailMobile extends Component<Props, State> {


  state: State = {fullscreen: {show: false, start: null}};


  componentDidMount(): void {
    this.handleViewPortCheck = this.handleViewPortCheck.bind(this);
    this.showFullscreen = this.showFullscreen.bind(this);
    this.updateLikeState();
  }

  componentDidUpdate(previousProps: Readonly<Props>, previousState: Readonly<State>, previousContext: any): void {
    if (this.props.product && this.props.variant) {
      const imageScrollContainer = this.getBase().querySelector('#detail-images-scroll-container');
      if (imageScrollContainer) {
        imageScrollContainer.addEventListener('scroll', this.handleViewPortCheck);
      }
      if (this.state.isLiked !== customerService.isVariantLiked(this.props.variant, this.props.likes)) {
        this.updateLikeState();
      }

      if (!this.state.visibleImage) {
        this.handleViewPortCheck();
      }
    }
  }

  componentWillUnmount() {
    const imageScrollContainer = this.getBase().querySelector('#detail-images-scroll-container');
    if (imageScrollContainer) {
      imageScrollContainer.removeEventListener('scroll', this.handleViewPortCheck);
    }
  }

  getBase(): HTMLElement {
    return this.base as HTMLElement;
  }

  private handleViewPortCheck() {
    this.props.variant.images.forEach((image: Image, index: number) => {
      const imgTag = this.getBase().querySelector(`#image_${index}`) as HTMLElement;
      if (imgTag && this.isElementInViewport(imgTag)) {
        this.setState({visibleImage: imgTag});
      }
    })
  }

  private isElementInViewport(el: HTMLElement) {
    if (el) {
      const rect = el.getBoundingClientRect();

      return (
        rect.top <= (window.innerHeight || document.documentElement.clientHeight) + 200 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) + 200 &&
        rect.right >= 0
      );
    }
  }

  private updateLikeState() {
    if (this.props.variant) {
      this.setState({isLiked: customerService.isVariantLiked(this.props.variant, this.props.likes)})
    }
  }

  private showFullscreen(image: Image) {
    this.setState({fullscreen: {show: true, start: image}});
  }

  render() {
    if (!this.props.product && !this.props.variant) {
      return (
        <div className={styles['product-not-found-container']}>
          <div className={styles['info-text']}>{i18nService.translate('detail_view_product_not_found')}</div>
          <div className={styles['filter-reset']}>
            <Button black={true} label={i18nService.translate('detail_view_back_to_products_button')}
                    onClickCallback={() => route('/products/')}/>
          </div>
        </div>
      );
    }

    const product = this.props.product;
    const variant = this.props.variant;

    return (
      <div id={'detail-mobile-scroll-container'} class={`${styles['detail-container']}`}>
        {this.state.fullscreen.show ?
          <ImagePreview onClickCallback={() =>
            this.setState({fullscreen: {show: false, start: null}})}
                        image={this.state.fullscreen.start}/> : null}

        <div class={`${styles['image-container']}`}>
          <button aria-label={"close"} class={styles['close']}
               onClick={() => navigationService.closeDetailView()}>{icons.renderCloseIcon()}</button>
          <ImageGallery product={this.props.product} variant={this.props.variant}
                                      onClickCallback={(image: Image) => this.showFullscreen(image)}/>
        </div>
        <div class={`${styles['info-container']}`}>
          {!NY_CountryService.isRestricted(App.countryCode) && <div class={styles['tag-like']}>
            {variant.hasTag() &&
              <div class={styles.tag}><ProductTag variant={variant} /></div>}
            <div class={`${styles.like} ${this.state.isLiked ? styles.fill : ''}`}
                 onClick={this.handleToggleLike.bind(this)}>{icons.renderHeartIcon()}</div>
          </div>}
          <div class={styles['product-info']}>
            <ProductInfoMobile product={product} variant={variant}/>
          </div>
        </div>
      </div>
    )
  }

  async handleToggleLike(e: Event) {
    e.stopPropagation();

    this.props.toggleLike(this.props.variant, !this.state.isLiked, Dimension.DETAIL);
    this.updateLikeState();
  }
}

export default connect(mapToProps, actions)(withDeviceIndicator(DetailMobile))
